import React from "react";

interface AspectRatioBoxProps {
    /** ratio in the format "width:height" e.g. "16:9" or "4:3" */
    ratio?: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

const AspectRatioBox: React.FC<AspectRatioBoxProps> = ({
                                                           ratio = "16:9",
                                                           children,
                                                           style = {},
                                                       }) => {
    const [width, height] = ratio.split(":");
    const paddingTop = (parseFloat(height) / parseFloat(width)) * 100;

    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                paddingTop: `${paddingTop}%`,
                ...style,
            }}
        >
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default AspectRatioBox;
